import '../se-heading/se-heading';
import '../se-social-link/se-social-link';
import '../se-button/se-button';
import '../se-container/se-container';
import { LitElement, html, TemplateResult } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { AdoptedStyleSheets } from '../../controllers/adopted-stylesheets';
import innerCSS from './se-location-hero.inner.pcss?inline';
import { SlotControllerLegacy } from '../../controllers/slot-controller-legacy';

/**
 * The Location Hero component.
 * @element se-location-hero
 *
 * @slot default - background image.
 */
@customElement('se-location-hero')
export class SeLocationHero extends LitElement {
  private stylesheetController = new AdoptedStyleSheets(this, {
    encapsulatedCSS: innerCSS,
  });
  slots = new SlotControllerLegacy(this, true);

  /**
   * Location Hero required attributes
   */
  @property({ type: String, attribute: 'header' })
  header: string;
  @property({ type: String, attribute: 'map-url' })
  mapURL: string;
  @property({ type: String, attribute: 'address1' })
  address1: string;
  @property({ type: String, attribute: 'address2' })
  address2: string;
  @property({ type: String, attribute: 'address3' })
  address3: string;
  @property({ type: String, attribute: 'phone' })
  phone: string;
  @property({ type: String, attribute: 'fax' })
  fax: string;
  @property({ type: String, attribute: 'description' })
  description: string;

  bgTemplate(): TemplateResult {
    return html`
      <div class="background-image">
        <slot name="background-image"></slot>
      </div>
    `;
  }

  cardTemplate(): TemplateResult {
    return html`
      <section class="location-card">
        <se-heading level="h1" class="location-name">${this.header}</se-heading>
        ${this.description
          ? html`<p class="location-description">${this.description}</p>`
          : ''}
        ${this.address1 || this.address2 || this.address3
          ? html`
              <se-link
                class="address"
                link-target="_blank"
                link-href="${this.mapURL}"
              >
                ${this.address1 ? html`<div>${this.address1}</div>` : ''}
                ${this.address2 ? html`<div>${this.address2}</div>` : ''}
                ${this.address3 ? html`<div>${this.address3}</div>` : ''}
              </se-link>
            `
          : ''}
        ${this.phone
          ? html`
              <span class="phone">
                Office:
                <se-link link-href="tel:${this.phone}">${this.phone}</se-link>
              </span>
            `
          : ''}
        ${this.fax ? html`<span class="fax">Fax: ${this.fax}</span>` : ''}
      </section>
    `;
  }

  render(): TemplateResult {
    return html`
      <section class="location-hero">
        ${this.bgTemplate()}
        <se-container justify-end>
          <div class="card-wrapper">${this.cardTemplate()}</div>
        </se-container>
      </section>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'se-location-hero': SeLocationHero;
  }
}
